import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

import { stopRemixThinking } from '../../editor-commands/stop-remix-thinking';
import type { MalleableUiPlugin } from '../../malleableUiPluginType';

/**
 * This function is used to cancel the remix thinking.
 * It will
 * - toggle the ai entry points to disabled-false
 * - stop the remix thinking
 *   - with reopenModal true if it is not an update
 */
export function cancelRemixThinking({
	api,
	reopenModal,
}: {
	api: ExtractInjectionAPI<MalleableUiPlugin> | undefined;
	reopenModal?: boolean;
}): void {
	// end the inline-Rovo streaming
	api?.aiExperience?.actions?.endInlineRovoStreaming?.();

	api?.aiExperience?.actions.toggleAiEntryPoints?.(false);

	if (expValEqualsNoExposure('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
		// If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
		// call the onCancel callback instead of reopening the remix modal.
		const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
		const userPrompt = remixModalMetadata?.userPrompt;
		const onCancel = remixModalMetadata?.onCancel;
		if (onCancel && userPrompt) {
			api?.core.actions.execute(stopRemixThinking({ reopenModal: false }));
			onCancel();
			return;
		}
	}

	const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
	api?.core.actions.execute(stopRemixThinking({ reopenModal: reopenModal ?? !isUpdate }));
}

/**
 * This function is used to handle the thinking bar complete-animation finished event.
 * It will
 * - toggle the ai entry points to disabled-false
 * - stop the remix thinking
 */
export function onRemixThinkingCompleteAnimationFinished({
	api,
}: {
	api: ExtractInjectionAPI<MalleableUiPlugin> | undefined;
}): void {
	api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
	api?.core.actions.execute(stopRemixThinking());
}
